import { render, staticRenderFns } from "./public-list-management.vue?vue&type=template&id=842c5854&scoped=true"
import script from "./public-list-management.vue?vue&type=script&lang=js"
export * from "./public-list-management.vue?vue&type=script&lang=js"
import style0 from "./public-list-management.vue?vue&type=style&index=0&id=842c5854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842c5854",
  null
  
)

export default component.exports